import React from 'react';
import { EditIcon } from '../../dashboard/components/product_item_components/icons';
import { formatPeriodRange } from '../../../utils/rentalPeriod';

export const SHIPMENT_PRODUCT_ID = -10;

export const isShipmentMovement = (movement) => {
  const productId = movement?.productId ?? movement?.product_id;
  return Number(productId) === SHIPMENT_PRODUCT_ID;
};

function OrderProductsSection({ stockMovements, isReplenishment, hideQuantity, onEditMovement }) {
  const orderedMovements = React.useMemo(() => {
    const shipments = [];
    const products = [];
    for (const movement of stockMovements) {
      if (isShipmentMovement(movement)) shipments.push(movement);
      else products.push(movement);
    }
    return [...shipments, ...products];
  }, [stockMovements]);

  const totalNum = orderedMovements.reduce((sum, m) => {
    const qty = m?.quantity ?? 0;
    const p = m?.productPrice ?? m?.product_price ?? 0;
    const price = typeof p === 'number' ? p : parseFloat(p) || 0;
    return sum + qty * price;
  }, 0);

  return (
    <section className="order-detail-section">
      <div className="order-detail-productsTitleRow">
        <h2 className="order-detail-productsTitle">Товары</h2>
        <span className="order-detail-productsTotal">
          Итого: {totalNum.toLocaleString('en-US', { minimumFractionDigits: 2 })} сом
        </span>
      </div>
      {orderedMovements.length === 0 ? (
        <p className="order-detail-empty">Нет товаров</p>
      ) : (
        <ul className="order-detail-productList">
          {orderedMovements.map((movement, index) => {
            const name = movement?.productName ?? movement?.product_name ?? '—';
            const qty = movement?.quantity ?? 0;
            const price = movement?.productPrice ?? movement?.product_price ?? 0;
            const priceNum = typeof price === 'number' ? price : parseFloat(price) || 0;
            const isShipment = isShipmentMovement(movement);
            const itemHideQty = hideQuantity || isShipment;

            return (
              <li
                key={movement?.id ?? index}
                className={[
                  'order-detail-productItem',
                  itemHideQty ? 'order-detail-productItem--hideQty' : '',
                  isShipment ? 'order-detail-productItem--shipment' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                <div className="order-detail-productMain">
                  {isShipment ? (
                    <span className="order-detail-shipmentBadge">Доставка</span>
                  ) : null}
                  <span className="order-detail-productName">{name}</span>
                  {movement?.fromAt || movement?.from_at ? (
                    <span className="order-detail-productPeriod">
                      {formatPeriodRange(movement.fromAt ?? movement.from_at, movement.toAt ?? movement.to_at)}
                    </span>
                  ) : null}
                </div>
                {!itemHideQty ? (
                  <span className="order-detail-productQty">{qty} шт.</span>
                ) : null}
                {!isReplenishment ? (
                  <span className="order-detail-productPrice">
                    {(qty * priceNum).toLocaleString('en-US', { minimumFractionDigits: 2 })} сом
                  </span>
                ) : null}
                <button
                  type="button"
                  className="order-detail-productEdit"
                  onClick={() => onEditMovement(movement)}
                  aria-label={
                    isShipment
                      ? 'Редактировать доставку'
                      : 'Редактировать количество и цену'
                  }
                  title="Редактировать"
                >
                  <EditIcon />
                </button>
              </li>
            );
          })}
        </ul>
      )}
    </section>
  );
}

export default OrderProductsSection;
